// extracted by mini-css-extract-plugin
export default {"pagelayout":"layouts_pagelayout__2Nch6"};